import { render } from "./disaChatDialogBox.vue?vue&type=template&id=312f6088&scoped=true&ts=true"
import script from "./disaChatDialogBox.vue?vue&type=script&lang=ts"
export * from "./disaChatDialogBox.vue?vue&type=script&lang=ts"

import "./disaChatDialogBox.vue?vue&type=style&index=0&id=312f6088&scoped=true&lang=css"
/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fapp%2FdisaChatDialogBox%2FdisaChatDialogBox.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312f6088"]])

export default __exports__